import { PostsContextlessPoliciesDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

export function useGroupsWithPostPermission() {
  const { data, loading } = useQuery(PostsContextlessPoliciesDocument)
  const canPostSomewhere = data?.posts?._policies?.groupCanPostSomewhere?.can ?? false

  return {
    groups: [],
    loading,
    canPostSomewhere,
  }
}
